
import { Calendar, Scan, Users, BarChart, Sparkles } from "lucide-react";

export const FeaturesSection = () => {
  const features = [
    {
      icon: Calendar,
      title: "Event Creation & Ticketing",
      description: "Set up events in minutes & sell tickets seamlessly"
    },
    {
      icon: Scan,
      title: "ID Scanning & Verification",
      description: "ScanTek & NocheTonto ID verification"
    },
    {
      icon: Users,
      title: "Smart Guest List Management",
      description: "Instant VIP & banned guest detection"
    },
    {
      icon: BarChart,
      title: "Real-Time Entry Dashboard",
      description: "Monitor crowd flow live"
    }
  ];

  return (
    <div id="features" className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center mb-16">
          <Sparkles className="w-12 h-12 text-purple-400 mb-4" />
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white">
            Why Choose NocheTonto?
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 rounded-xl bg-gray-900/50 backdrop-blur-sm border border-gray-800 hover:border-gray-700 transition-all duration-300"
            >
              <feature.icon className="w-12 h-12 text-purple-400 mb-4 mx-auto" />
              <h3 className="text-xl font-semibold text-white mb-2 text-center">{feature.title}</h3>
              <p className="text-gray-400 text-center">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
